import { Injectable } from '@angular/core';

export interface IndicatorResult {
    text: string;
    color: string;
    level: string;
}

@Injectable({
    providedIn: 'root'
})
export class AirQualityService {

    /**
     * 計算舒適指標 (依據溫度)
     */
    getComfortIndicator(value: string | number | null | undefined): IndicatorResult {
        const temp = Number(value);  
        if (temp <= 17) return { text: `寒冷(${temp})`, color: 'text-blue-400', level: '寒冷' };
        if (temp <= 26) return { text: `舒適(${temp})`, color: 'text-green-400', level: '舒適' };
        if (temp <= 30) return { text: `炎熱(${temp})`, color: 'text-yellow-400', level: '炎熱' };
        return { text: `酷熱(${temp})`, color: 'text-red-500', level: '酷熱' };
    }

    /**
     * 計算空氣品質指標 (依據 AQI/PM2.5)
     */
    getQualityIndicator(value: string | number | null | undefined): IndicatorResult {
        const aqi = Number(value);
        if (aqi <= 100) return { text: `良好(${aqi})`, color: 'text-green-400', level: '良' };
        if (aqi <= 200) return { text: `警示(${aqi})`, color: 'text-yellow-400', level: '警示' };
        return { text: `危害(${aqi})`, color: 'text-red-500', level: '危害' };
    }
}


